import React, { useEffect, useState } from "react";
import { AddCharge, GiveSubscription } from "../../pages";
import { BroadcastController, ChargeController } from "../../controllers";
import { adminStore, chargeStore } from "../../stores";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";
import * as yup from "yup";
import SubscriptionController from "../../controllers/SubscriptionController";
import { toJS } from "mobx";

const GiveSubscriptionContainer = ({ closeModal, item }) => {
  const [loading, setLoading] = useState(false);

  const isSignedUpBusiness = item.subscription;

  useEffect(() => {
    const fetchPlan = async () => {
      setLoading(true);
      await BroadcastController.getPlans();
      setLoading(false);
    };

    fetchPlan();
  }, []);

  const validationSchema = () => {
    return yup.object().shape({
      business: yup.string().required("Enter business name"),
      amountPaid: yup.string().required("Enter amount paid"),
      plan: yup.string().required("Select Plan"),
      months: yup.string().required("Enter number of months"),
    });
  };

  const onSubmit = async (values) => {
    setLoading(true);

    const payload = {
      business: isSignedUpBusiness
        ? item.subscription.business
        : item.business._id,
      amountPaid: values.amountPaid.toString(),
      plan: values.plan,
      // plan: values.plan ? values.plan : item.plan._id || item.subscription._id,
      months: values.months.toString(),
    };

    const { status, errorMessage } =
      await SubscriptionController.giveSubscription(payload);
    if (status === constant.Success) {
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
      return closeModal();
    }
    MimaToastUtil.error({
      message: errorMessage,
    });
    setLoading(false);
  };

  return (
    <GiveSubscription
      closeModal={closeModal}
      onSubmit={onSubmit}
      loading={loading}
      validationSchema={validationSchema}
      item={item}
      plans={toJS(adminStore.plans)}
      isSignedUpBusiness={isSignedUpBusiness}
    />
  );
};
export default GiveSubscriptionContainer;
